export enum WebClientSize {
  WEB_CLIENT_SIZE_UNKNOWN = 'WEB_CLIENT_SIZE_UNKNOWN',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
  XLARGE_DESKTOP = 'XLARGE_DESKTOP',
}
